import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { MenuItem } from '../menu-item/MenuItem';

import { navProps } from './Navigation.consts';
import styles from './Navigation.module.scss';

export type TMenuItem = {
  name: string;
  to?: string;
  renderIcon: (className: string) => ReactNode;
  notifications?: {
    count: number;
  };
  onClick?: () => void;
};

type Props = {
  isOpened: boolean;
  onCloseSidebar(): void;
};

export const Navigation = observer(function Navigation({ isOpened, onCloseSidebar }: Props) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      {navProps.map((nav) => {
        if (!nav.isShown) {
          return null;
        }

        const isActive = location.pathname === nav.to;
        const onClick = () => {
          onCloseSidebar();

          if (nav.isExternalLink) {
            window.open(nav.to, '_blank');
            return;
          }

          navigate(nav.to);
        };

        return <MenuItem key={nav.to} isActive={isActive} isOpened={isOpened} item={nav} onClick={onClick} />;
      })}
    </div>
  );
});
